import React from 'react';
import { Col, Row, Button } from '@oscar/theme';
import { TextField } from 'common/components';
import moment from 'moment';
import { SAP_STATUS_LIST } from 'common/constants/insulation';
import { FORMAT_DATE } from 'common/constants';
import { useFormContext } from '@oscar/form';

export const SearchResult = (props: any) => {
  const { addItem, field, readOnly, removeItem, resetItem, item } = props;
  const [formContext] = useFormContext();
  const idRes = formContext.selectors?.getInitalValue()?.ePTWNo;
  // Check if current PTW already exists in the list
  const listPTWDetail = formContext.form?.getFieldValue('listPTWDetail') || [];
  const isAlreadyInList =
    item?.ePTWId &&
    listPTWDetail.some((ptw: any) => ptw?.ePTWId === item.ePTWId);
  return (
    <div className="notification-detail">
      {!readOnly && (
        <div className="notification-detail-title">PTW Details</div>
      )}
      <div className="notification-detail-content">
        {item ? (
          <div>
            <Row gutter={12}>
              <Col span={24}>
                <div className="search-header">
                  <div className="search-header_id">
                    <TextField label="ePTW ID" value={item?.ePTWId} />
                  </div>
                  {!field && item && !readOnly && !isAlreadyInList && (
                    <div>
                      <Button
                        type="secondary"
                        size="small"
                        className="reset-button"
                        onClick={() => {
                          resetItem?.();
                        }}
                      >
                        Reset
                      </Button>{' '}
                      <Button
                        type="primary"
                        className="add-to-list-button"
                        onClick={() => addItem?.(item)}
                      >
                        Add to list
                      </Button>
                    </div>
                  )}
                  {field &&
                    !readOnly &&
                    item &&
                    !idRes?.ePTWNoRemoval?.includes(item?.ePTWId) && (
                      <Button
                        type="primary"
                        className="update-button"
                        onClick={() => {
                          removeItem?.(field);
                        }}
                        size="small"
                      >
                        Remove from list
                      </Button>
                    )}
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <div className="notification-detail-content-placeholder">
            Enter a PTW number above and click the plus icon to add it to the
            list.
          </div>
        )}
      </div>
    </div>
  );
};
